/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { Colors, Heading, Typography } from '@zapier/design-system';
import { createKeyHandler } from '@zapier/product-get-help/esm/utils';
import { isolateComponent } from '@zapier/style-encapsulation';
import { rebrandFocusCss } from '@zapier/product-get-help/esm/styles';
import ZapIcons from '../ZapIcons';
import { DEFAULT_ZAP_NAME } from '../constants';
const zapCss = css `
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: 100px 1fr;
  align-items: center;
  justify-items: start;
  height: 50px;
  padding: 0 15px;
  ${Typography.smallPrint1Semibold}
  color: ${Colors.neutral800};
  ${rebrandFocusCss}
  &:hover,
  &:focus {
    background-color: ${Colors.blue10};
    border-color: ${Colors.blue10};
    color: ${Colors.blueJeans};
  }
`;
const headingCss = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
/** Renders a single Zap within `<Folders>`. */
const Zap = ({ onClick: _onClick, nodes, title }) => {
    const onClick = (e) => {
        _onClick();
        // because the whole folder is focusable and thus toggleable,
        // we need to prevent it from closing when you click a Zap.
        e.stopPropagation();
    };
    return (isolateComponent("li", null,
        isolateComponent("div", { css: zapCss, onClick: onClick, onKeyDown: createKeyHandler(['enter'], onClick), role: "button", tabIndex: 0 },
            isolateComponent(ZapIcons, { nodes: nodes }),
            isolateComponent(Heading, { css: headingCss }, title || DEFAULT_ZAP_NAME))));
};
export default Zap;
